import { render, staticRenderFns } from "./rukuZhi.vue?vue&type=template&id=058e71c3&scoped=true&"
import script from "./rukuZhi.vue?vue&type=script&lang=js&"
export * from "./rukuZhi.vue?vue&type=script&lang=js&"
import style0 from "./rukuZhi.vue?vue&type=style&index=0&id=058e71c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e71c3",
  null
  
)

export default component.exports